import React, { useState, useEffect, useContext } from 'react';
import { TablaCabeceraPractica } from './TablaCabeceraPractica';
import { TablaComentarios } from './TablaComentarios';
import { AppContext } from './../AppContext';
//import Swal from 'sweetalert2'
//import withReactContent from 'sweetalert2-react-content'

//const MySwal = withReactContent(Swal);

//const TITLE = process.env.REACT_APP_TITLE;
const TITLE = "Reportes de Retroalimentación Estudiantil";
const APIURL = process.env.REACT_APP_API_URL;

function ComentariosPractica({ match }) {

    document.title = TITLE + " - Comentarios por tutor";

    const [practica, setPractica] = useState(null);
    const [comentarios, setComentarios] = useState([]);
    const [loading, setLoading] = useState(true);

    const currentUser = useContext(AppContext).currentUser;

    useEffect(() => {
        const { anio, codigo, identificacion } = match.params;

        if (currentUser && currentUser != undefined) {
            populateData(anio, codigo, identificacion);
        }
    }, [match.params]);

    async function populateData(anio, codigo, identificacion) {
        try {
            const response = await fetch(`${APIURL}/api/reporte-usuario/practica-profesor/${anio}/${codigo}/${identificacion}`);
            const data = await response.json();

            const dataResponse = await fetch(`${APIURL}/api/reporte-usuario/practica-profesor-comentarios/${anio}/${codigo}/${identificacion}`);
            const dataComentarios = await dataResponse.json();

            setPractica(data);
            setComentarios(dataComentarios);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching data:', error);
            setLoading(false);
        }
    }

    function renderTable(practica, data) {
        let comentario = [];
        data.forEach(c => {
            if (c.comentario && c.comentario.length > 0) {
                comentario.push(c.comentario);
            }
        });

        return (
            <>
                <TablaCabeceraPractica practica={practica} />
                <br />
                {comentario && comentario.length > 0 && <TablaComentarios tipo={"Comentarios"} comentarios={comentario} />}
            </>
        );
    }

    return (
        <div>
            <h1 id="tabelLabel" className="text-center">Comentarios por Tutor</h1>
            {loading ? <p><em>Loading...</em></p> : renderTable(practica, comentarios)}
        </div>
    );
}

export default ComentariosPractica;
